/*

    <a href='https://airtable.com/shrzMcypjWPdZaeLL'>Rent Roll Increase</a>
    <a href='portalhelp@mbhp.org'>Account Support/Assistance</a>
    <a href='gateway@metrohousingboston.org'>Questions on Account</a>
*/
import { Table, Form } from 'react-bootstrap';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import axiosInstance from '../axios';

import CustomPagination from '../components/CustomPagination';
import TableHeadSortTypeIndicator from '../components/TableHeadSortTypeIndicator';
import CustomDateRangePicker from '../components/CustomDateRangePicker';
import PaymentDetailsModal from '../components/PaymentDetailsModal';
import { exportPaymentsToExcel } from '../utils/exportPayments';
import { maskTaxId } from '../utils/maskTaxId';
/**
 * Navigation Menu section for Links on website
 * @returns 
 * 
 *    
 * Removed Code Below (Header Logo icon on left)         
<a className='navbar-brand' href='/#'>
    Metro Housing Boston
</a>
 */

const fetchPayments = async (page, limit, source, otherPayload = {}) => {
    try {
        const response = await axiosInstance.post('/payments', {
            page,
            limit,
            source,
            ...otherPayload
        });
        return response.data;
    } catch (error) {
        console.log('Error fetching payments:', error);
    }
};

const STORAGE_FROM_KEY = 'HAPPYPAYMENTS_DATE_FROM';
const STORAGE_TO_KEY = 'HAPPYPAYMENTS_DATE_TO';

const getSavedDate = (key, fallback) => {
    const raw = localStorage.getItem(key);
    if (raw && moment(raw).isValid()) return raw;
    return fallback;
};

export default function HAPPYPAYMENTS({ payments, setPayments, taxId }) {
    const [pagination, setPagination] = useState({ page: 1, limit: 25 });
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [sortBy, setSortBy] = useState('CHECKDATE')
    const [sortByType, setSortByType] = useState('DESC')
    const [checkNumInput, setCheckNumInput] = useState('');
    const [checkNum, setCheckNum] = useState('');
    const [from, setFrom] = useState(() =>
        getSavedDate(STORAGE_FROM_KEY, moment().subtract(30, 'day').toISOString())
    );
    const [to, setTo] = useState(() =>
        getSavedDate(STORAGE_TO_KEY, moment().toISOString())
    );

    useEffect(() => {
        if (from && to) {
            localStorage.setItem(STORAGE_FROM_KEY, from);
            localStorage.setItem(STORAGE_TO_KEY, to);
        }
    }, [from, to]);

    const renderDate = (date) => {
        return date && moment(date).isValid() ? moment(date).utc().format('MM-DD-YYYY') : '';
    }

    const renderAmount = (amount) => {
        return amount && amount.startsWith("$") ? amount : `$${amount}`;
    }

    const onClickHead = (key) => {
        if (key === sortBy) {
            setSortByType(prev => prev === 'ASC' ? 'DESC' : 'ASC')
        } else {
            setSortBy(key)
        }
        if (pagination.page !== 1) {
            setPagination(prev => ({ ...prev, page: 1 }))
        }
    }

    const handleOnApplyDates = (event, picker) => {
        const nextFrom = moment(picker.startDate).toISOString();
        const nextTo = moment(picker.endDate).toISOString();
        setFrom(nextFrom);
        setTo(nextTo);
    };

    const applyPastQuarter = () => {
        const nextFrom = moment().subtract(3, 'months').startOf('day').toISOString();
        const nextTo = moment().endOf('day').toISOString();
        setFrom(nextFrom);
        setTo(nextTo);
        localStorage.removeItem(STORAGE_FROM_KEY);
        localStorage.removeItem(STORAGE_TO_KEY);
        if (pagination.page !== 1) {
            setPagination(prev => ({ ...prev, page: 1 }))
        }
    };

    const applyPastYear = () => {
        const nextFrom = moment().subtract(1, 'year').startOf('day').toISOString();
        const nextTo = moment().endOf('day').toISOString();
        setFrom(nextFrom);
        setTo(nextTo);
        localStorage.removeItem(STORAGE_FROM_KEY);
        localStorage.removeItem(STORAGE_TO_KEY);
        if (pagination.page !== 1) {
            setPagination(prev => ({ ...prev, page: 1 }))
        }
    }

    const handleCheckNumChange = (event) => {
        const nextValue = event.target.value;
        setCheckNumInput(nextValue);
        if (!nextValue.trim()) {
            setCheckNum('');
            if (pagination.page !== 1) {
                setPagination(prev => ({ ...prev, page: 1 }))
            }
        }
    };

    const applyCheckNumSearch = () => {
        setCheckNum(checkNumInput.trim());
        if (pagination.page !== 1) {
            setPagination(prev => ({ ...prev, page: 1 }))
        }
    };

    useEffect(() => {
        setLoading(true);
        const normalizedCheckNum = checkNum ? checkNum.trim() : '';
        fetchPayments(pagination.page, pagination.limit, "HAPPYPAYMENTS", {
            sortBy: sortBy,
            sortByType: sortByType,
            from: normalizedCheckNum ? undefined : moment(from).format('YYYY-MM-DD'),
            to: normalizedCheckNum ? undefined : moment(to).format('YYYY-MM-DD'),
            fromKey: normalizedCheckNum ? undefined : 'CHECKDATE',
            taxId,
            checkNum: normalizedCheckNum || undefined,
        })
            .then(result => {
                setLoading(false);
                if (result && result.success) {
                    setPayments(result.items);
                    setTotalCount(result.totalCount);
                }
            }).catch(error => {
                setLoading(false);
                console.error(error);
            });
    }, [pagination, sortBy, sortByType, from, to, taxId, checkNum, setPayments]);

    const normalizedCheckNum = checkNum ? checkNum.trim().toLowerCase() : '';
    const visiblePayments = normalizedCheckNum
        ? (payments || []).filter((payment) =>
            String(payment.CHECKNUM ?? '').trim().toLowerCase() === normalizedCheckNum
        )
        : payments;
    const visibleTotalCount = normalizedCheckNum ? visiblePayments.length : totalCount;

    return (
        <div className='payments'  >
            <h3 className='userdataLabel emphTitle' >RAFT/HOMEBASE PAYMENTS</h3>

            {loading ? (
                <div>Loading...</div>
            ) : (
                <>
                    <div className='d-flex justify-content-end gap-2 flex-row flex-wrap'>
                        <Form.Select style={{ maxWidth: 'max-content' }} value={sortBy} onChange={(ev) => setSortBy(ev.target.value)}>
                            <option value="OWNER_NUMBER">Owner #</option>
                            <option value="PAYMENT_TAXID">Tax ID</option>
                            <option value="CHECKDATE">Check Date</option>
                            <option value="CHECKNUM">Check #</option>
                            <option value="AMOUNT">Amount</option>
                            <option value="ADDRESS">Address</option>
                            <option value="CITY">City</option>
                            <option value="TENNAME">Tenant</option>
                            <option value="TRANSTYPE">Type</option>
                        </Form.Select>
                        <Form.Select style={{ maxWidth: 'max-content' }} value={sortByType} onChange={(ev) => setSortByType(ev.target.value)}>
                            <option value="ASC">Low to high</option>
                            <option value="DESC">High to low</option>
                        </Form.Select>

                        <Form.Control
                            style={{ maxWidth: 180 }}
                            placeholder="Search Check #"
                            value={checkNumInput}
                            onChange={handleCheckNumChange}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    applyCheckNumSearch();
                                }
                            }}
                        />
                        <button type="button" className="btn btn-outline-secondary date-range-preset-btn" onClick={applyCheckNumSearch}>
                            Search
                        </button>

                        <button type="button" className="btn btn-outline-secondary date-range-preset-btn" onClick={applyPastQuarter}>
                            Past Quarter
                        </button>
                        <button type="button" className="btn btn-outline-secondary date-range-preset-btn" onClick={applyPastYear}>
                            Past Year
                        </button>

                        <CustomDateRangePicker from={from} to={to} onApply={handleOnApplyDates} />
                    </div>
                    <Table className="table mt-2">
                        <thead>
                            <tr>
                                <th className='tableheader' scope="col" onClick={() => onClickHead('OWNER_NUMBER')}>
                                    OWNER #
                                    {sortBy === 'OWNER_NUMBER' && <TableHeadSortTypeIndicator sortByType={sortByType} />}
                                </th>
                                <th className='tableheader' scope="col" onClick={() => onClickHead('PAYMENT_TAXID')}>
                                    TAX ID
                                    {sortBy === 'PAYMENT_TAXID' && <TableHeadSortTypeIndicator sortByType={sortByType} />}
                                </th>
                                <th className='tableheader' scope="col" onClick={() => onClickHead('CHECKDATE')}>
                                    CHECKDATE
                                    {sortBy === 'CHECKDATE' && <TableHeadSortTypeIndicator sortByType={sortByType} />}
                                </th>
                                <th className='tableheader' scope="col" onClick={() => onClickHead('CHECKNUM')}>
                                    CHECK NUMBER
                                    {sortBy === 'CHECKNUM' && <TableHeadSortTypeIndicator sortByType={sortByType} />}
                                </th>
                                <th className='tableheader' scope="col" onClick={() => onClickHead('AMOUNT')}>
                                    AMOUNT
                                    {sortBy === 'AMOUNT' && <TableHeadSortTypeIndicator sortByType={sortByType} />}
                                </th>
                                <th className='tableheader' scope="col" onClick={() => onClickHead('ADDRESS')}>
                                    ADDRESS
                                    {sortBy === 'ADDRESS' && <TableHeadSortTypeIndicator sortByType={sortByType} />}
                                </th>
                                <th className='tableheader' scope="col" onClick={() => onClickHead('CITY')}>
                                    CITY
                                    {sortBy === 'CITY' && <TableHeadSortTypeIndicator sortByType={sortByType} />}
                                </th>
                                <th className='tableheader' scope="col" onClick={() => onClickHead('TENNAME')}>
                                    TENANT NAME
                                    {sortBy === 'TENNAME' && <TableHeadSortTypeIndicator sortByType={sortByType} />}
                                </th>
                                <th className='tableheader' scope="col" onClick={() => onClickHead('TRANSTYPE')}>
                                    TRANSACTION TYPE
                                    {sortBy === 'TRANSTYPE' && <TableHeadSortTypeIndicator sortByType={sortByType} />}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {visiblePayments.map((payment, index) => (
                                <tr className='' key={index}>
                                    <td>{payment.OWNER_NUMBER}</td>
                                    <td>{maskTaxId(payment.PAYMENT_TAXID)}</td>
                                    <td>{renderDate(payment.CHECKDATE)}</td>
                                    <td><PaymentDetailsModal payment={payment} source="HAPPYPAYMENTS" /></td>
                                    <td>{renderAmount(payment.AMOUNT)}</td>
                                    <td>{payment.ADDRESS}</td>
                                    <td>{payment.CITY}</td>
                                    <td>{payment.TENNAME}</td>
                                    <td>{payment.TRANSTYPE}</td>
                                </tr>
                            ))}
                            <tr>
                                <td className='text-end px-2' colSpan="4">Total</td>
                                <td className='text-end px-2'>
                                    {(() => {
                                        const total = (visiblePayments || []).reduce((acc, p) => {
                                            const raw = String(p.AMOUNT ?? '0');
                                            const cleaned = raw.replace(/[^\d.-]/g, '');
                                            const n = Number(cleaned);
                                            return acc + (isNaN(n) ? 0 : n);
                                        }, 0);
                                        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total);
                                    })()}
                                </td>
                                <td className='text-end px-2' colSpan="4">
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={() => exportPaymentsToExcel('HOMEBASE Payments', visiblePayments)}
                                    >
                                        Export HOMEBASE
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                    <CustomPagination
                        page={pagination.page}
                        limit={pagination.limit}
                        total={visibleTotalCount}
                        onPageChange={(val) => setPagination(prev => ({ ...prev, page: val }))}
                        onLimitChange={(ev) => setPagination(prev => ({ ...prev, limit: Number(ev.target.value) }))}
                    />
                </>
            )}
            <hr></hr>
        </div>
    );
}

/*

    <a href='https://airtable.com/shrzMcypjWPdZaeLL'>Rent Roll Increase</a>
    <a href='portalhelp@mbhp.org'>Account Support/Assistance</a>
    <a href='gateway@metrohousingboston.org'>Questions on Account</a>
*/
